// The header's one "eBay Return" field (2026-11-02, docs/contact-view.md).
// The order summary's ebayReturnFound carries the return whether the server
// searched for it or read a return the contact already knows (a prior
// suggestion's return id, a RETURN-type thread, the resend-return-label
// flow), so the header shows "eBay Return <id> (<status>)" with its link on
// every turn, instead of switching between a searched "eBay Return" field and
// a bare known "Return ID" field.
//
// Before the summary loads (or with no order to summarize), a known
// conversation.returnId still shows, without a status. Once the summary has
// answered, it alone decides: a saved return from an order the contact has
// moved off (2026-11-02) is not shown.
//
// A RETURN-type thread keeps its own reference field ("eBay Return", the
// thread's referenceId): when the return is that same one, the status and
// link go on the reference field and no second field is shown.
//
// Returns { found, reference }:
//   found      { id, value, href } for the separate "eBay Return" field, or null
//   reference  { value, href } for a RETURN-type thread's reference field, or null
import { ebayReturnDetailsUrl } from './ebayLinks.js'

export function headerEbayReturn({ conversation, orderSummary } = {}) {
  const live = orderSummary?.ebayReturnFound
  const ret = live?.id != null
    ? { id: String(live.id), status: live.status ?? null }
    : (!(orderSummary && 'ebayReturnFound' in orderSummary) && conversation?.returnId != null && conversation.returnId !== '' ? { id: String(conversation.returnId), status: null } : null)
  const label = (r) => (r.status ? `${r.id} (${r.status})` : r.id)

  let reference = null
  if (conversation?.referenceType === 'RETURN' && conversation.referenceId) {
    const refId = String(conversation.referenceId)
    reference = ret && ret.id === refId
      ? { value: label(ret), href: ebayReturnDetailsUrl(refId) }
      : { value: refId, href: ebayReturnDetailsUrl(refId) }
  }
  const found = ret && !(reference && ret.id === String(conversation.referenceId))
    ? { id: ret.id, value: label(ret), href: ebayReturnDetailsUrl(ret.id) }
    : null
  return { found, reference }
}
